import { render, staticRenderFns } from "./ActivableOrdersList.vue?vue&type=template&id=2b61a603&scoped=true&"
import script from "./ActivableOrdersList.vue?vue&type=script&lang=js&"
export * from "./ActivableOrdersList.vue?vue&type=script&lang=js&"
import style0 from "./ActivableOrdersList.vue?vue&type=style&index=0&id=2b61a603&lang=scss&scoped=true&"
import style1 from "./ActivableOrdersList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b61a603",
  null
  
)

export default component.exports